import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { formattedMorphUserName } from '../utils/helpers/CommonHelper';

export function useEduCourseLecturersInformation(courseDetail) {
  const { t } = useTranslation();

  return useMemo(() => {
    if (!courseDetail) return [];

    return [
      {
        label: t('Hlavný lektor'),
        value: formattedMorphUserName(courseDetail.lecturerable),
      },
      {
        label: t('Ďalší lektori'),
        value: (courseDetail?.lecturers || []).map((lecturer) => (
          <p key={lecturer.id} style={{ paddingLeft: 0 }}>
            {formattedMorphUserName(lecturer.lecturerable)}
          </p>
        )),
      },
    ];
  }, [courseDetail, t]);
}
